export enum ServiceLineStatuses {
    Denied = 'Denied',
    Pending = 'Pending',
    Approved = 'Approved',
    Cancelled = 'Cancelled',
    Dismissed = 'Dismissed',
    PartiallyFavorable = 'Partially Favorable',
    NonAdmit = 'Non-Admit'
}
